import { render } from "./Click15Icon.vue?vue&type=template&id=3f6d7e84"
import script from "./Click15Icon.vue?vue&type=script&lang=js"
export * from "./Click15Icon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__